import script from "./dealer_types.vue?vue&type=script&setup=true&lang=js"
export * from "./dealer_types.vue?vue&type=script&setup=true&lang=js"

import "./dealer_types.vue?vue&type=style&index=0&id=372368f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372368f6"]])

export default __exports__